import { SmartInterestType, SMART_INTEREST_SELECTION_HISTORY } from '../../../const/state/adgroup';
import { ref, computed } from 'vue-demi';
const state = {
  smart_interest_selection: ref(SmartInterestType.CHECK),
  selection_history: ref(SMART_INTEREST_SELECTION_HISTORY.UNEDITED),
  showSmartInterestToggle: ref(false),
};

const getters = {
  getSmartInterestSelection: computed(() => state.smart_interest_selection.value),
  getEditHistory: computed(() => state.selection_history.value),
  getDisplayToggle: computed(() => state.showSmartInterestToggle.value),
};

export { state, getters };
